export default __webpack_public_path__ + "450057be69fde5ecbaaf64719e3d77bc.svg";